import { webApiService } from '@/services'
import { Box, Button, CircularProgress, Grid, TextField, Typography } from '@mui/material'
import { enqueueSnackbar } from 'notistack'
import React, { useState } from 'react'
import { useTradeinContext } from '../hooks/useTradeinContext'
import SerieHelper from './SerieHelper'
import SerieConsole from './SerieConsole'
import NUIAlert from '@/components/Alert/Alert'
import { useSelector } from 'react-redux'
import { IConfigSeller } from '@/models/configSeller'
import { isConsole } from '@/utils/isConsole'

const DeviceMobile: React.FC<any> = () => {
  const { ctx, saveCtx } = useTradeinContext()
  const [loading, setLoading] = useState(false)
  const configSeller = useSelector((store: { config: IConfigSeller }) => store.config)
  const isSamsungMexico = configSeller.config.s3.FOLDER_APP === 'ti_samsung_mx'
  const isHuaweiOnlineChile = configSeller.config.s3.FOLDER_APP === 'ti_huawei_online_cl'
  const isHuaweiOnlineMexico = configSeller.config.s3.FOLDER_APP === 'ti_huawei_online_mx'
  const isHuaweiOnlinePeru = configSeller.config.s3.FOLDER_APP === 'ti_huawei_online_pe'
  // Huawei Online ingresa la serie recién cuando el dispositivo está en bodega (estado 11); el resto en estado 1
  const canEnterSerie = ctx.tradein.id_status === ((isHuaweiOnlineChile || isHuaweiOnlineMexico || isHuaweiOnlinePeru) ? 11 : 1) && ctx.tradein.serie === null && ctx.tradein.sbu !== 'Notebook'
  const isLiverpoolMexico = configSeller.config.s3.FOLDER_APP === 'ti_liverpool_mx'
  // Solo Liverpool México ingresa la serie de la consola con la foto de la etiqueta, que se manda a
  // leer al backend. El resto de los sellers con consolas (Mercado Libre, etc.) la escribe a mano.
  const needsSerieFoto = isLiverpoolMexico && isConsole(ctx.tradein.sbu)

  const handleSerieChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    saveCtx({ ...ctx, serie: event.target.value })
  }

  const handleSerieSave = (serie: string, suggested?: string | null) => {
    setLoading(true)

    webApiService.update({ stage: 7, id: ctx.tradein.id, serie, id_seller: ctx.tradein.id_seller, serie_suggested: suggested ?? null })
      .then(() => {
        enqueueSnackbar('Se actualizó el número de IMEI/serie.', { variant: 'success' })
      })
      .catch((error) => {
        enqueueSnackbar('Hubo un error al intentar guardar el número de IMEI/serie.', { variant: 'error' })
        console.log('error ==>', error)
      }).finally(() => {
        saveCtx({ ...ctx, reload: true })
        setLoading(false)
      })
  }
  // console.log('ctx', ctx.tradein)
  return (
    <div className='bg-white rounded-lg shadow-lg p-4'>
      <h6 className='border-b-1 mb-2 font-bold text-xl pb-2'>Dispositivo</h6>
      <div className='grid grid-cols-12'>
        <div className='col-span-12' hidden={!isSamsungMexico}>
          <p className='mb-2'><strong>Modelo Samsung:</strong> {ctx.tradein.samsung_name}</p>
        </div>
        <div className='col-span-12'>
          <p><strong>Tipo:</strong> {ctx.tradein.sbu}</p>
        </div>
        <div className='col-span-12'>
          <p><strong>Marca:</strong> {ctx.tradein.brand}</p>
        </div>
        <div className='col-span-12'>
          <p><strong>Modelo:</strong> {ctx.tradein.model}</p>
        </div>
        {ctx.tradein.sbu === 'Notebook' && (
          <>
            <div className='col-span-12'>
              <p><strong>CPU:</strong> {ctx.tradein.cpu}</p>
            </div>
            <div className='col-span-12'>
              <p><strong>Generación del CPU:</strong> {ctx.tradein.cpu_generation}</p>
            </div>
            <div className='col-span-12'>
              <p><strong>Pantalla:</strong> {ctx.tradein.screen}</p>
            </div>
            <div className='col-span-12'>
              <p><strong>Memoria RAM:</strong> {ctx.tradein.ram}</p>
            </div>
            <div className='col-span-12'>
              <p><strong>Almacenamiento:</strong> {ctx.tradein.capacity}</p>
            </div>
          </>
        )}
        <div className='col-span-12'>
          <p><strong>N° de serie: </strong></p>
        </div>
        <Grid item xs={12} className='col-span-12'>
          {canEnterSerie && needsSerieFoto
            ? (
              <SerieConsole onSave={handleSerieSave} saving={loading} />
              )
            : (
              <Typography variant='body1'>
                {loading
                  ? (
                    <CircularProgress />
                    )
                  : (
                      canEnterSerie
                        ? (
                          <Box position='relative' display='flex' alignItems='center' mt={2} mb={2}>
                            <Box position='relative' flexGrow={1} mr={2}>
                              <TextField
                                className='search-box'
                                label='Agregar serie'
                                variant='outlined'
                                size='small'
                                value={ctx.serie}
                                onChange={handleSerieChange}
                                style={{ width: '100%' }}
                              />
                              <SerieHelper style={{ position: 'absolute', top: 0, right: 0, transform: 'translate(50%, -50%)' }} />
                            </Box>
                            <Button
                              variant='contained'
                              size='small'
                              color='primary'
                              onClick={() => handleSerieSave(ctx.serie)}
                            >
                              Guardar
                            </Button>
                          </Box>
                          )
                        : (
                            ctx.tradein.serie
                          )
                    )}
              </Typography>
              )}
          {(isHuaweiOnlineChile || isHuaweiOnlineMexico || isHuaweiOnlinePeru) && ctx.tradein.id_status === 1 && ctx.tradein.serie === null && ctx.tradein.sbu !== 'Notebook' && (
            <NUIAlert type='warning'>
              Debe ingresar el dispositivo a bodega para poder continuar con el proceso.
            </NUIAlert>
          )}
          {canEnterSerie && (
            <NUIAlert type='warning'>
              Debe ingresar el N° de Serie del dispositivo
            </NUIAlert>
          )}
        </Grid>
      </div>
    </div>
  )
}

export default DeviceMobile
